/* istanbul ignore file */
import React from 'react';
import { Progress, RadialProgress } from '@bingads-webui-react/progress';
import { DefaultButton } from '@bingads-webui-react/fabric-control';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';

const ProgressBar = (props) => {
  const {
    i18n,
    uploadpercentage,
    onCancelUpload,
    isRadial,
  } = props;
  const theme = useTheme();

  return (
    <div className="upload-progress" >
      <div>
        {!isRadial && `${uploadpercentage}%`}
      </div>
      {isRadial? <RadialProgress progressPercentage={uploadpercentage} stroke={_.get(theme, ['core', 'palette', 'blue'])} size={64} strokeWidth={5} /> :
      <Progress progressPercentage={uploadpercentage} stroke={_.get(theme, ['core', 'palette', 'blue'])} size={64} strokeWidth={5} />}
      <DefaultButton
        ariaLabel={`${i18n.getString('Audience_Campaign_Cancel_Label')} ${i18n.getString('ImageExperience_Upload')}`}
        text={i18n.getString('Audience_Campaign_Cancel_Label')}
        onClick={onCancelUpload}
      />
    </div>
  );
};

ProgressBar.propTypes = {
  i18n: PropTypes.string.isRequired,
  uploadpercentage: PropTypes.func.isRequired,
  onCancelUpload: PropTypes.string.isRequired,
  isRadial: PropTypes.bool,
};

ProgressBar.defaultProps = {
  isRadial: false,
};

export default ProgressBar;
